import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_up_thin",
  "use": "chevron_up_thin-usage",
  "viewBox": "0 0 16 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 24\" id=\"chevron_up_thin\"><path d=\"m7 9.427 3.33 3.331a.58.58 0 1 1-.822.823L7 11.073l-2.503 2.502a.58.58 0 1 1-.822-.822z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol